import { useEffect } from 'react';

/** 强力清理器：1) 干掉“ようこそ {{name}}”幽灵文本；2) 干掉常见聊天机器人挂件 */
export default function GlobalFixes() {
  useEffect(() => {
    // —— 1) 隐藏“ようこそ {{name}}”类占位符（任何位置、任何组件）——
    const hideWelcomeGhost = () => {
      // 只处理纯文本小节点，避免大块组件被误伤
      const nodes = Array.from(document.querySelectorAll<HTMLElement>('body *'))
        .filter(el => el.childElementCount === 0 && !!el.textContent);

      nodes.forEach(el => {
        const txt = (el.textContent || '').trim();
        // 命中典型占位符形态
        if (/{{\s*name\s*}}/.test(txt) && /ようこそ|欢迎/.test(txt)) {
          // 不删 DOM，防止布局跳动，仅隐藏
          el.style.display = 'none';
        }
      });
    };

    // —— 2) 清理常见聊天机器人（Crisp / Tawk.to / Intercom / Chatbase / Landbot 等）——
    const killChatWidgets = () => {
      // Crisp
      try { (window as any).$crisp?.push?.(['do', 'chat:close']); } catch {}
      document.querySelectorAll(
        'script[src*="crisp.chat"], link[href*="crisp.chat"], iframe[src*="crisp.chat"], .crisp-client, #crisp-chatbox'
      ).forEach(el => (el as HTMLElement).style.display = 'none');

      // Tawk.to
      document.querySelectorAll(
        'script[src*="tawk.to"], [id^="tawk_"], iframe[src*="tawk.to"]'
      ).forEach(el => (el as HTMLElement).style.display = 'none');

      // Intercom
      try { (window as any).Intercom?.('shutdown'); } catch {}
      document.querySelectorAll(
        'script[src*="intercom.io"], #intercom-container, iframe[name="intercom-frame"]'
      ).forEach(el => (el as HTMLElement).style.display = 'none');

      // Chatbase
      document.querySelectorAll(
        'script[src*="chatbase.co"], iframe[src*="chatbase.co"], [class*="chatbase"]'
      ).forEach(el => (el as HTMLElement).style.display = 'none');

      // Landbot
      document.querySelectorAll(
        'script[src*="landbot"], iframe[src*="landbot"], [id*="landbot"]'
      ).forEach(el => (el as HTMLElement).style.display = 'none');
    };

    // 先执行一遍
    hideWelcomeGhost();
    killChatWidgets();

    // 监听 DOM 变化，防止它们二次挂载
    const mo = new MutationObserver(() => {
      hideWelcomeGhost();
      killChatWidgets();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    // 也监听路由切换（SPA 常见）
    window.addEventListener('popstate', hideWelcomeGhost);
    window.addEventListener('hashchange', hideWelcomeGhost);

    return () => {
      mo.disconnect();
      window.removeEventListener('popstate', hideWelcomeGhost);
      window.removeEventListener('hashchange', hideWelcomeGhost);
    };
  }, []);

  return null;
}
